import collectionApiClient from '../../../api/collections';
import useKlydoQuery from '../../../hooks/useKlydoQuery';

export const useAffiliateLinkQuery = (collectionId: string) =>
  useKlydoQuery<{ url: string }>({
    queryKey: ['affiliate-link', collectionId],
    queryFn: () => collectionApiClient.getAffiliateLink(collectionId),
    enabled: false,
    staleTime: Infinity,
    gcTime: Infinity,
  });
